var map = {
	"./montserrat/montserrat-bold.woff": 14599,
	"./montserrat/montserrat-regular.woff": 76536,
	"./openSans/opensans-bold.woff": 68391,
	"./openSans/opensans-extrabold.woff": 68073,
	"./openSans/opensans-italic.woff": 15716,
	"./openSans/opensans-light.woff": 12896,
	"./openSans/opensans-regular.woff": 42552,
	"./openSans/opensans-semibold.woff": 28585
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41662;